import React from 'react';
import { resolveStyle } from './base_components';

type Props = {
  style?: any;
  value: any;
  placeholder?: string;
  className?: string;
  onChange: (value: string) => void;
  children?: any;
};

export default class FileInput extends React.PureComponent<Props> {
  _ref = React.createRef<HTMLInputElement>();
  getFile() {
    let ret;
    const { current } = this._ref;
    if (current && current.files) {
      ret = current.files[0];
    }
    return ret;
  }
  getFiles() {
    let ret;
    const { current } = this._ref;
    if (current) {
      ret = current.files;
    }
    return ret;
  }

  _onChange = (e) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(e.target.value);
    }
  };
  render() {
    const {
      style,
      className: extraClass,
      value,
      onChange: _,
      children,
      ...other_props
    } = this.props;

    const { className, inlineStyle } = resolveStyle(style, extraClass);

    return (
      <input
        ref={this._ref}
        className={className}
        style={inlineStyle}
        {...other_props}
        type='file'
        value={value}
        onChange={this._onChange}
      >
        {children}
      </input>
    );
  }
}
